const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';
import { apiFetch } from './interceptor';

export const betLimitsApi = {
  getBetLimits: async (token, page = 1, limit = 20) => {
    try {
      const response = await apiFetch(`${BASE_URL}/combinationLimits?page=${page}&limit=${limit}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching bet limits:", error);
      throw error;
    }
  },

  createBetLimit: async (token, limitData) => {
    try {
      const response = await apiFetch(`${BASE_URL}/combinationLimits`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(limitData)
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error creating bet limit:", error);
      throw error;
    }
  },

  updateBetLimit: async (token, id, limitData) => {
    try {
      const response = await apiFetch(`${BASE_URL}/combinationLimits/${id}`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(limitData)
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error updating bet limit:", error);
      throw error;
    }
  },

  deleteBetLimit: async (token, id) => {
    try {
      const response = await apiFetch(`${BASE_URL}/combinationLimits/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      // Check if we got a redirected response
      if (response && response.redirected) {
        return { redirected: true };
      }
      
      // Handle both cases: response with content or empty response
      if (response.status === 204) {
        return { success: true };
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error deleting bet limit:", error);
      throw error;
    }
  }
}; 